import React from 'react'
import { useStyles } from "./styles";
import {
    Card,
    Divider,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tab,
    Button,
    Grid,
    TableContainer,
    Radio
} from "@material-ui/core";
import { Link } from 'react-router-dom';
import { connect, useDispatch } from "react-redux";
import { useParams } from 'react-router'

function TableBodyData(props: any) {
    const classes = useStyles();
    const params: any = useParams()
    const element: any = props.elementData;
    const [popUpSubscribe, setPopUpSubscribe] = React.useState<any>(false)
    const dispatch = useDispatch()
 
    // console.log('id___', params.id)

    return (
        <>
        <TableRow key={element.id}>
            <TableCell className={classes.tableBody} style={{ paddingLeft: 15 }}>              
                {element.addonName}
            </TableCell>
            <TableCell className={classes.tableBody}>
                {element.currency}${element.cost}        
            </TableCell>
            <TableCell className={classes.tableBody}>
                {element.currency}${element.cost}     
            </TableCell>
        </TableRow>
     
     </>
    )
}

export default TableBodyData
